module.exports = __webpack_public_path__ + "static/media/emailssmsalerts.21d163bf.gif";